<template>
  <div>
    <b-sidebar
      id="add-bus-sidebar"
      sidebar-class="sidebar-lg"
      bg-variant="white"
      :visible="addServiceSidebar"
      right
      no-header
      backdrop
      @hidden="(val) => changeValue(val)"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <h5
            class="mb-0"
          >
            {{ pajakLocal.id > 0 ? 'Edit Pajak' : 'Add Pajak' }}
          </h5>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="hide"
          />
        </div>

        <!-- Body -->
        <validation-observer
          ref="simpleRules"
          class="px-2"
        >
          <b-form>
            <b-row class="px-2">
              <b-col md="12">
                <b-form-group
                  label="Nama Pajak"
                  label-for="name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Nama Pajak"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="pajakLocal.nama"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Nama Pajak"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Keterangan"
                  label-for="keterangan"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Keterangan"
                    rules="required"
                  >
                    <b-form-textarea
                      id="keterangan-pajak"
                      v-model="pajakLocal.keterangan"
                      placeholder="Keterangan"
                      rows="3"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Tenggat"
                  label-for="tenggat"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Tenggat"
                    rules="required"
                  >
                    <b-form-datepicker
                      id="tenggat"
                      v-model="pajakLocal.jatuh_tempo"
                      :state="errors.length > 0 ? false:null"
                      class="mb-1"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group
                  label="Biaya"
                  label-for="biaya"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Biaya"
                    rules="required"
                  >
                    <b-form-input
                      id="biaya"
                      v-model="pajakLocal.jumlah"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Biaya"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="pajakLocal.id === null"
                md="12"
              >
                <b-form-group
                  label="Status Bayar"
                  label-for="status-status"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status"
                    rules="required"
                  >
                    <b-form-select
                      id="status-status"
                      v-model="pajakLocal.status"
                      :options="options"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Status"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- <b-col md="12">
                <b-form-group
                  label="Bukti Pembayaran"
                  label-for="foto-bukti-pembayaran"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Bukti Pembayaran"
                    rules="required"
                  >
                    <b-form-file
                      id="foto-bukti-pembayaran"
                      v-model="pajakLocal.bukti_pembayaran"
                      accept="image/*"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Pilih File"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col> -->
              <b-col md="12">
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="submit()"
                >
                  Submit
                </b-button>
                <b-button
                  variant="outline-secondary"
                  @click="changeValue(false)"
                >
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BButton, BCol,
  BRow, BSidebar, BFormDatepicker, BFormSelect, BFormTextarea,
} from 'bootstrap-vue'
import { required, email } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BCol,
    BRow,
    BSidebar,
    BFormDatepicker,
    BFormSelect,
    BFormTextarea,
  },
  model: {
    prop: 'addServiceSidebar',
  },
  props: {
    addServiceSidebar: {
      type: Boolean,
      required: true,
    },
    pajak: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      email,
      pajakLocal: {
        id: null,
        name: null,
        keterangan: null,
        jatuh_tempo: null,
        jumlah: null,
        status: null,
      },
      options: [
        { value: 'belum_dibayar', text: 'Belum Dibayar' },
        { value: 'sudah_dibayar', text: 'Sudah Dibayar' },
      ],
    }
  },
  watch: {
    pajak() {
      this.resetTaskLocal()
    },
  },
  methods: {
    resetTaskLocal() {
      this.pajakLocal = {
        id: this.pajak.id,
        nama: this.pajak.nama,
        keterangan: this.pajak.keterangan,
        jatuh_tempo: this.pajak.jatuh_tempo,
        jumlah: this.pajak.jumlah,
        status: this.pajak.status,
      }
    },
    changeValue() {
      const data = {
        id: null,
        nama: null,
        keterangan: null,
        jatuh_tempo: null,
        jumlah: null,
        status: null,
      }
      this.$emit('pajak-sidebar-change', data, false)
    },
    submit() {
      if (this.pajakLocal.id > 0) {
        this.$emit('submit-data-pajak', this.pajakLocal)
      } else {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            this.$emit('submit-data-pajak', this.pajakLocal)
          }
        })
      }
    },
  },
}
</script>
<style>
.b-sidebar-body {
  overflow: hidden !important;
}
</style>
